import RegistrationComponent from '../views/register/Registration';

const Registration = ({ rejoin = false }) => {
  return <RegistrationComponent rejoin={rejoin} />;
};

export default Registration;
